<template>
  <v-list shaped>
    <v-list-item v-for="(item, i) in sceneList" :key="i" link @click.stop="checkedEditor(item)">
      <v-list-item-content>
        <v-list-item-title class="text-h6" v-text="item.name"></v-list-item-title>
        <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <div class="pa-10 text-center" v-if="sceneList.length === 0">暂无数据</div>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['sceneList'])
  },
  data: () => ({
    selectedItem: 1
  }),
  methods: {
    checkedEditor(scene) {
      this.$store.dispatch('editor/checkEditor', Object.assign({}, scene))
    }
  }
}
</script>
